<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.mes-production-terminal.terminal-create-production-note.error.http' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">
		{{ 'mes.mes-production-terminal.terminal-create-production-note.title' | translate: { alias: itemOperation.alias } }}
	</h1>

	<mat-dialog-content>
		<div class="note-layout pad-top-20">
			<div class="note-left">
				<mat-form-field appearance="outline" class="dialog">
					@if (controls['sequenceNumber'].invalid && controls['sequenceNumber'].touched) {
						<mat-error>
							{{ 'mes.mes-production-terminal.terminal-create-production-note.error.sequence-number' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.mes-production-terminal.terminal-create-production-note.sequence-number' | translate }}
					</mat-label>
					<mat-select formControlName="sequenceNumber">
						@for (sequenceNumber of availableSequenceNumbers; track sequenceNumber) {
							<mat-option [value]="sequenceNumber">
								{{ sequenceNumber }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field appearance="outline" class="dialog">
					@if (controls['employee'].invalid && controls['employee'].touched) {
						<mat-error>
							{{ 'mes.mes-production-terminal.terminal-create-production-note.error.employee' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.mes-production-terminal.terminal-create-production-note.employee' | translate }}
					</mat-label>
					<input maxlength="255" matInput formControlName="employee" cdkFocusInitial />
				</mat-form-field>
			</div>

			<div class="note-right">
				<mat-form-field appearance="outline" class="dialog note-field">
					<mat-label class="mat-body-1">
						{{ 'mes.mes-production-terminal.terminal-create-production-note.note' | translate }}
					</mat-label>
					<textarea matInput formControlName="note" rows="10" maxlength="255"></textarea>
				</mat-form-field>
			</div>
		</div>
		<app-reorder-production-note-list [alias]="itemOperation.alias" [employees]="employees"></app-reorder-production-note-list>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">
			{{ 'general.ok' | translate }}
		</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
			{{ 'general.cancel' | translate }}
		</button>
	</mat-dialog-actions>
</form>
